var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 526 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eb0000;}.cls-2{fill:#524e4d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 268.02,
    y: 4.56,
    width: 6.42,
    height: 31.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "242.29 4.56 229.96 36.52 236.7 36.52 245.78 12.16 254.85 36.52 261.59 36.52 249.26 4.56 242.29 4.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.93 4.56 82.6 36.52 89.34 36.52 98.42 12.16 107.49 36.52 114.23 36.52 101.91 4.56 94.93 4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.17,24.29a6.4,6.4,0,0,1-6.41,6.28,6.14,6.14,0,0,1-6.41-5.85.76.76,0,0,1,0-.15v-20h-6.42v20a12.84,12.84,0,0,0,25.67,0h0v-20h-6.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.86,14.57a10.05,10.05,0,0,0-10.07-10H200.16v32h6.32V10.15H214A4.43,4.43,0,0,1,214,19h-5.14l9.33,17.56h6.88L218.24,24h0A10,10,0,0,0,224.86,14.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "147.46 4.56 138.05 17.4 128.63 4.56 120.72 4.56 120.72 4.56 120.72 36.52 127.14 36.52 127.14 13.28 138.05 27.8 148.96 13.28 148.96 36.52 155.38 36.52 155.38 4.56 155.38 4.56 147.46 4.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.6,17.47h-9a3.26,3.26,0,0,1-3.18-3.26A3.21,3.21,0,0,1,59.55,11H75.48l3.4-6.38H59.58A9.6,9.6,0,0,0,50,14.16a9.5,9.5,0,0,0,9.57,9.41h9a3.26,3.26,0,1,1,0,6.52h-16l-3.4,6.39H68.57A9.6,9.6,0,0,0,78.24,27v0a9.49,9.49,0,0,0-9.52-9.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.58,24,13.35,39.28A20,20,0,0,1,20.24.57a19.69,19.69,0,0,1,2.87.21L9.32,14.57A6.82,6.82,0,0,0,19,24.24h0l5-5a3.3,3.3,0,0,1,4.65,0,3.35,3.35,0,0,1,0,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27,1.77,11.81,17.09a3.36,3.36,0,0,0,0,4.7,3.2,3.2,0,0,0,4.65,0l5-5A6.78,6.78,0,0,1,31,16.73l.05.06a6.86,6.86,0,0,1,0,9.66L17.32,40.27a19.93,19.93,0,0,0,2.88.21A20,20,0,0,0,27,1.77Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30D1\\u30BF\\u30FC\\u30F31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "489.75 4.38 482.52 15.68 475.3 4.38 468.22 4.38 479.3 20.59 479.3 36.63 485.75 36.63 485.75 20.59 496.82 4.38 489.75 4.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 409.58,
    y: 4.38,
    width: 6.25,
    height: 32.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "421.9 20.3 434.34 4.38 427.31 4.38 414.64 20.49 427.31 36.63 434.7 36.63 421.9 20.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "390.92 4.38 385.03 4.38 384.47 4.38 372.09 36.63 378.86 36.63 387.98 12.05 397.09 36.63 403.86 36.63 391.48 4.38 390.92 4.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "512.65 4.38 506.76 4.38 506.2 4.38 493.82 36.63 500.59 36.63 509.7 12.05 518.82 36.63 525.59 36.63 513.21 4.38 512.65 4.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.89,14.49A10.11,10.11,0,0,0,356.78,4.38h-14.7V36.63h6.37V10H356A4.47,4.47,0,0,1,356,19h-5.15l3,5.64h0l6.36,12h6.91L360.27,24a10.11,10.11,0,0,0,6.62-9.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M452.1,4.38a15.56,15.56,0,0,1,11.4,4.85A16,16,0,0,1,468.22,21a15.82,15.82,0,0,1-4.76,11.57,16.32,16.32,0,0,1-23.14-.22,16.14,16.14,0,0,1-4.61-11.59,16.3,16.3,0,0,1,2.2-8.25,16.37,16.37,0,0,1,14.19-8.1M452,10.21a9.8,9.8,0,0,0-7.31,3,10.53,10.53,0,0,0-3,7.67,10,10,0,0,0,3.69,8.22A10.2,10.2,0,0,0,452,31.47a9.66,9.66,0,0,0,7.23-3,10.4,10.4,0,0,0,3-7.53,10.48,10.48,0,0,0-3-7.58A9.78,9.78,0,0,0,452,10.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "284.24 4.38 284.24 4.39 287.48 10.5 294.37 10.5 294.37 36.63 300.82 36.63 300.82 10.5 307.72 10.5 310.95 4.4 310.95 4.38 284.24 4.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "333.01 30.7 322.23 30.7 322.23 23.24 332.56 23.24 332.56 17.65 322.23 17.65 322.23 10.29 333.01 10.29 336.14 4.38 315.95 4.38 315.95 36.61 336.14 36.61 333.01 30.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.efe3ff5302edf68a89729a216d29c614.svg";
export { ForwardRef as ReactComponent };